import { ESpeedMeasurementUnit } from "../@types";

export function convertSpeed(
	value: number,
	from: ESpeedMeasurementUnit,
	to: ESpeedMeasurementUnit,
) {
	switch (from) {
		case ESpeedMeasurementUnit.KILOMETERS_PER_HOUR:
			switch (to) {
				case ESpeedMeasurementUnit.KILOMETERS_PER_HOUR:
					return value;
				case ESpeedMeasurementUnit.MILES_PER_HOUR:
					return value * 0.621371;
				case ESpeedMeasurementUnit.METERS_PER_SECOND:
					return value * 0.277778;
				case ESpeedMeasurementUnit.KNOTS:
					return value * 0.539957;
				default:
					return value;
			}
		case ESpeedMeasurementUnit.MILES_PER_HOUR:
			switch (to) {
				case ESpeedMeasurementUnit.KILOMETERS_PER_HOUR:
					return value * 1.60934;
				case ESpeedMeasurementUnit.MILES_PER_HOUR:
					return value;
				case ESpeedMeasurementUnit.METERS_PER_SECOND:
					return value * 0.44704;
				case ESpeedMeasurementUnit.KNOTS:
					return value * 0.868976;
				default:
					return value;
			}
		case ESpeedMeasurementUnit.METERS_PER_SECOND:
			switch (to) {
				case ESpeedMeasurementUnit.KILOMETERS_PER_HOUR:
					return value * 3.6;
				case ESpeedMeasurementUnit.MILES_PER_HOUR:
					return value * 2.23694;
				case ESpeedMeasurementUnit.METERS_PER_SECOND:
					return value;
				case ESpeedMeasurementUnit.KNOTS:
					return value * 1.94384;
				default:
					return value;
			}
		case ESpeedMeasurementUnit.KNOTS:
			switch (to) {
				case ESpeedMeasurementUnit.KILOMETERS_PER_HOUR:
					return value * 1.852;
				case ESpeedMeasurementUnit.MILES_PER_HOUR:
					return value * 1.15078;
				case ESpeedMeasurementUnit.METERS_PER_SECOND:
					return value * 0.514444;
				case ESpeedMeasurementUnit.KNOTS:
					return value;
				default:
					return value;
			}
		default:
			return value;
	}
}
